/**
 * Created by Gayratjon Rayimjonov on 10/24/2017.
 */
(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('stats-periodical', {
                parent: 'entity',
                url: '/stats-periodical',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGER'],
                    pageTitle: 'global.menu.statistics.periodical'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/stats-periodical/stats-periodical.html',
                        controller: 'StatsPeriodicalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('statsMerchants');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            });
    }

})();
